function ApiConstants() {
  const apiBaseUrl = 'https://uvibes-api.lobbi.dev/';
  const authentication = 'auth/';
  const company = 'company/';
  const question = 'question/';
  const session = 'session/';
  const user = 'user/';
  const reward = 'reward/';
  const userReward = 'user-reward/';
  const meeting = 'meeting/';
  const survey = 'survey/';
  const surveyAnswer = 'survey-answer/';
  const actuality = 'actuality/';
  const visit = 'visit/';
  const theme = 'theme/';
  const userTheme = 'user-theme/';
  const reportCategory = 'report-category/';
  const report = 'report/';
  const resource = 'resource/';
  const favorite = 'favorite/';
  const questionCourse = 'question-course/';
  const answer = 'answer/';
  const userResource = 'user-resource/';
  const certif = 'certif/';

  return {
    apiBaseUrl: apiBaseUrl,
    authentication: authentication,
    company: company,
    question: question,
    session: session,
    user: user,
    reward: reward,
    meeting: meeting,
    survey: survey,
    surveyAnswer: surveyAnswer,
    actuality: actuality,
    visit: visit,
    theme: theme,
    userTheme: userTheme,
    reportCategory: reportCategory,
    report: report,
    resource: resource,
    favorite: favorite,
    questionCourse: questionCourse,
    answer: answer,
    userReward: userReward,
    userResource: userResource,
    certif: certif,
  };
}

export default ApiConstants;
